import { useState, useMemo, useContext, useEffect } from "react";
import {
  Layout,
  Menu,
  Avatar,
  Image,
  Dropdown,
  Space,
  Button,
  Typography,
} from "antd";
import {
  BellOutlined,
  DownOutlined,
  UserOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";

import { getAuthenticatedUser } from "../../apis/auth";
import ChangeTheme from "../ChangeTheme";
import ThemeContext from "../../utils/context/Theme/ThemeContext";
import TestTypeContext from "../../utils/context/TestType/TestTypeContext";
import NotificationDashList from "../NotificationDashList";
import Changelang from "../Changelang";
import LogoutForm from "../../pages/Auth/LogoutForm";

import userProfileImage from "../../assets/images/userProfileImage.png";
import "./DashboardHeader.css";
import "../../pages/DashboardAll/Dashboard/DarkDash.css";
import { setDataLocalStorage } from "../../utils/helpers/localStorageHelper";

const DashboardHeader = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("dashboardHeader");
  const { themeMode, changeTheme } = useContext(ThemeContext);
  const { changeToPaperType, changeToElectronicType } =
    useContext(TestTypeContext);

  const [user, setUser] = useState({
    name: "Guest",
    image: userProfileImage,
  });

  const dropdownUserItems = useMemo(
    () => [
      {
        key: "1",
        icon: <UserOutlined className="me-10" />,
        label: <Typography.Text>{user.name}</Typography.Text>,
      },
      {
        key: "2",
        icon: <LogoutOutlined className="me-10" />,
        label: <LogoutForm />,
      },
    ],
    [user.name],
  );

  const dropdownSettItems = useMemo(
    () => [
      {
        key: "1",
        label: t("dashboardHeaderItems.settings.menu.label"),
        type: "group",
        children: [
          {
            key: "1-1",
            label: (
              <Typography.Text onClick={changeToPaperType}>
                {t("dashboardHeaderItems.settings.menu.children.item1")}
              </Typography.Text>
            ),
          },
          {
            key: "1-2",
            label: (
              <Typography.Text onClick={changeToElectronicType}>
                {t("dashboardHeaderItems.settings.menu.children.item2")}
              </Typography.Text>
            ),
          },
        ],
      },
    ],
    [changeToPaperType, changeToElectronicType, t],
  );

  const navItems = useMemo(
    () => [
      {
        key: "1",
        icon: <NotificationDashList />,
      },
      {
        key: "2",
        icon: <ChangeTheme />,
        onClick: changeTheme,
      },
      {
        key: "3",
        icon: <Changelang />,
      },
    ],
    [changeTheme],
  );

  useEffect(() => {
    (async () => {
      try {
        const userData = await getAuthenticatedUser();
        setUser({
          name: userData?.user.name,
          image: userData?.user.profile_photo_url,
        });
        setDataLocalStorage("user name", user.name)
      } catch (error) {
        console.error("Failed to fetch user data:", error);
        setUser({ name: "Guest", image: userProfileImage });
      }
    })();
  }, []);

  return (
    <Layout.Header
      className={classNames("header-dashboard flex relative", {
        lightDashHeader: themeMode === "light",
        darkDashHeader: themeMode === "dark",
        mobDashHeader: isMobile,
      })}
    >
      <Space wrap size={12}>
        <Dropdown
          menu={{ items: dropdownUserItems }}
          placement={i18n.dir() === "ltr" ? "bottomLeft" : "bottomRight"}
          trigger={["click"]}
          overlayClassName={classNames("dash-header-dropdown user-dropdown", {
            darkDropDown: themeMode === "dark",
          })}
        >
          <Typography.Text
            className="ant-dropdown-link fw-bold"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <Avatar
              src={
                <Image preview={false} src={user.image} style={{ width: 30 }} />
              }
            />
            <DownOutlined className="ms-5" />
          </Typography.Text>
        </Dropdown>

        <Menu
          mode="horizontal"
          className="border-0"
          items={navItems.map(({ key, icon, onClick }) => ({
            key,
            icon,
            onClick,
          }))}
        />

        <Dropdown
          menu={{
            items: dropdownSettItems,
            selectable: true,
            defaultSelectedKeys: ["1"],
          }}
          placement={i18n.dir() === "ltr" ? "bottomLeft" : "bottomRight"}
          trigger={["click"]}
          overlayClassName={classNames("dash-header-dropdown", {
            darkDropDown: themeMode === "dark",
          })}
        >
          <Typography.Text
            className="ant-dropdown-link fw-bold"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            {t("dashboardHeaderItems.settings.label")}
            <DownOutlined className="ms-5" />
          </Typography.Text>
        </Dropdown>

        <Button
          type="ghost"
          shape="round"
          className="subscribe-btn border-0"
          onClick={() => navigate("/plansSection")}
        >
          {t("dashboardHeaderItems.buttons.subscribeLabel")}
        </Button>
      </Space>

      {/* {isNotiMenu && <NotificationDashList theme={themeMode} />} */}
    </Layout.Header>
  );
};

export default DashboardHeader;
